import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import * as $ from 'jquery';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  data: any ={};
  today: number = Date.now();
  updatedTime : any;
  notifications: Array<any> = [];
  error: any;
  notificationId: any;
  value: any;
  lat: any;
  lng: any;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private serviceURLService: serviceURLService, private router: Router) { }
  if (navigator) {
    navigator.geolocation.getCurrentPosition(pos => {
      this.lng = +pos.coords.longitude;
      this.lat = +pos.coords.latitude;
    });
  }
  ngOnInit() {
    this.notification();
  }
  notification(){
    this.data = {
      "updatedTime": null,
      
    }

    this.serviceURLService.notification(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      this.notifications = successData.response.notifications;
      for (let i = 0; i < (successData.response.notifications).length; i++) {
        this.notificationId = successData.response.notifications[i]._id;
      }
    }, errorData => {
      console.log("not registered");
    })
  }

  deleteNotification() {
    this.notificationId =  this.value._id;
    this.data = {
      "_id": this.notificationId,
    }
    this.serviceURLService.deleteNotification(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log("Notification deleted successfully..!!");
      window.location.reload();
      //this.router.navigate(['home']);
      
    }, (errorData) => {
      if(errorData.error.status === 401){
        this.router.navigate(['registration']);
      }else if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
      console.log("not registered");
    })

  }

  openDeleteModal(value:any){
    this.value = value;
  }

  syncNotification() {
    this.notificationId =  this.value._id;
    this.data = {
      "_id": this.notificationId,
    }
    this.serviceURLService.viewNotification(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      for (let i = 0; i < (successData.response.notifications).length; i++) {
        this.notificationId = successData.response.notifications[i]._id;
      }
    }, (errorData) => {
      if(errorData.error.status === 401){
        this.router.navigate(['registration']);
      }else if(errorData.error.status === 403){
        this.error = errorData.error.message;
      }
      
      
      console.log("not registered");
    })

  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}
